import reducer from "../pages/redux/slice"


const reducers={
    data:reducer,
    
 
}

export default reducers